import { render, staticRenderFns } from "./MonthSmeltingProductInfoList.vue?vue&type=template&id=5b072c05&"
import script from "./MonthSmeltingProductInfoList.vue?vue&type=script&lang=js&"
export * from "./MonthSmeltingProductInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports